/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import NaturalDay from './cpns/NaturalDay.vue';
import CustomLog from './cpns/CustomLog.vue';
import AggregateAccount from './cpns/AggregateAccount.vue';
import CTypeTab from '@/components/CTypeTab.vue';
export default defineComponent({
  name: 'ProReportMortar',
  components: {
    NaturalDay: NaturalDay,
    CustomLog: CustomLog,
    AggregateAccount: AggregateAccount,
    CTypeTab: CTypeTab
  },
  setup: function setup() {
    // const formatDate = (date?: Date) => {
    //   return dayjs(date).format('YYYY/MM/DD');
    // };
    var isShowComponent = ref(true);
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              tabIndex.value = val;
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var tabIndex = ref(0);
    var componentArray = ref(['NaturalDay', 'AggregateAccount', 'AggregateAccount', 'AggregateAccount', 'CustomLog']);
    var curTabComponent = computed(function () {
      return componentArray.value[tabIndex.value];
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            isShowComponent.value = false;
            _context2.next = 3;
            return nextTick();
          case 3:
            isShowComponent.value = true;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    return {
      confirmType: confirmType,
      tabIndex: tabIndex,
      isShowComponent: isShowComponent,
      curTabComponent: curTabComponent
    };
  }
});